/* Some page loads evaluate this file twice — all three bundle scripts throw
   "already been declared" in the same second, so it is the document being
   re-evaluated rather than a duplicate <script> tag. A bare `class X {}` is
   fatal on the second pass, so bail out once the class is already there. */
if (!window.ModalManager) {

class ModalManager {
  constructor(options = {}) {
    console.log('ModalManager initialisiert');
    this.options = {
      id: 'customModal',
      title: 'Modal Title',
      content: '',
      closeButton: true,
      dragToClose: true,
      overlay: true,
      position: 'bottom',
      containerClass: '',
      onOpen: () => {},
      onClose: () => {},
      ...options,
    };

    this.isOpen = false;
    this.startY = 0;
    this.currentY = 0;

    this.moveModalToBody();
    this.setupModalStyles();
  }

  moveModalToBody() {
    const modal = document.getElementById(this.options.id);
    if (modal) {
      modal.remove();
      document.body.appendChild(modal);
    }
  }

  setupModalStyles() {
    const modal = document.getElementById(this.options.id);
    if (!modal) return;

    // Desktop Modal
    const desktopModal = modal.querySelector('.md\\:flex');
    if (desktopModal) {
      // Hauptcontainer Styling
      desktopModal.style.setProperty('height', '100vh', 'important');
      desktopModal.style.setProperty('align-items', 'center', 'important');

      // Dialog Container
      const dialogContainer = desktopModal.querySelector('.flex.min-h-full');
      if (dialogContainer) {
        dialogContainer.style.setProperty('width', '100%', 'important');
        dialogContainer.style.setProperty('max-height', '90vh', 'important');
      }

      // Content Container
      const contentContainer = desktopModal.querySelector('.sm\\:w-full');
      if (contentContainer) {
        contentContainer.style.setProperty('max-height', '85vh', 'important');
        contentContainer.style.setProperty('width', '90%', 'important');
        contentContainer.style.setProperty('max-width', '1200px', 'important');
        contentContainer.style.setProperty('margin', '0 auto', 'important');
      }

      // Grid Container (scrollbar hier)
      const gridContainer = modal.querySelector('.grid');
      if (gridContainer) {
        gridContainer.style.setProperty('max-height', 'calc(85vh - 100px)', 'important');
        gridContainer.style.setProperty('overflow-y', 'auto', 'important');
        gridContainer.style.setProperty('scroll-behavior', 'smooth', 'important');
        // Scrollbar Styling
        gridContainer.style.setProperty('scrollbar-width', 'thin', 'important');
        gridContainer.style.setProperty('scrollbar-color', '#888 #f1f1f1', 'important');
      }
    }

    // Mobile Bottom Sheet
    const bottomSheet = modal.querySelector('#bottomSheet');
    if (bottomSheet) {
      bottomSheet.style.setProperty('transform', 'translateY(100%)', 'important');
    }
  }

  open() {
    if (!this.isOpen) {
      const modal = document.getElementById(this.options.id);
      const bottomSheet = document.getElementById('bottomSheet');
      const desktopModal = modal.querySelector('.md\\:flex');

      if (modal) {
        // Hauptmodal anzeigen
        modal.style.setProperty('display', 'block', 'important');

        // Desktop/Mobile Handling
        if (window.innerWidth >= 768) {
          if (desktopModal) {
            desktopModal.style.setProperty('display', 'flex', 'important');
          }
        } else {
          if (bottomSheet) {
            bottomSheet.style.setProperty('transform', 'translateY(0)', 'important');
          }
        }

        document.body.style.overflow = 'hidden';
      }

      this.isOpen = true;
      this.options.onOpen();
    }
  }

  close() {
    if (!this.isOpen) return;

    const modal = document.getElementById(this.options.id);
    const bottomSheet = document.getElementById('bottomSheet');
    const desktopModal = modal.querySelector('.md\\:flex');

    if (window.innerWidth < 768 && bottomSheet) {
      // Mobile Animation
      bottomSheet.style.setProperty('transform', 'translateY(100%)', 'important');

      setTimeout(() => {
        this.hideModal(modal, desktopModal);
      }, 300);
    } else {
      // Desktop sofort schließen
      this.hideModal(modal, desktopModal);
    }
  }

  hideModal(modal, desktopModal) {
    if (modal) {
      modal.style.setProperty('display', 'none', 'important');
      if (desktopModal) {
        desktopModal.style.setProperty('display', 'none', 'important');
      }
      document.body.style.overflow = '';
    }
    this.isOpen = false;
    this.options.onClose();
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }
}

window.ModalManager = ModalManager;

}
